import { createReducer } from '@reduxjs/toolkit'
import {
    dStatisticsSetDailyLoaderAC,
    dStatisticsSetDailyStatisticDataAC,
    dStatisticsSetHoursStatisticDataAC,
    dStatisticsSetLoaderAC,
    dStatisticsSetMainSaleAmountDailyStatisticDataAC,
    dStatisticsSetPaymentMethodAmountStatisticDataAC,
    dStatisticsSetPaymentMethodCountStatisticDataAC,
    dStatisticsSetSaleTypeAmountStatisticDataAC,
    dStatisticsSetPeriodAC,
    dStatisticsSetRefundStatisticDataAC,
    dStatisticsSetSaleStatisticDataAC,
    dStatisticsSetStoriesAC,
    dStatisticsSetWeekDayStatisticDataAC,
    dStatisticsSetMainSaleAmountWeeklyStatisticDataAC,
    dStatisticsSetMainSaleAmountMonthlyStatisticDataAC,
    dStatisticsSetMainSaleCountDailyStatisticDataAC,
    dStatisticsSetMainSaleCountWeeklyStatisticDataAC,
    dStatisticsSetMainSaleCountMonthlyStatisticDataAC,
    dStatisticsSetMainSaleAverageDailyStatisticDataAC,
    dStatisticsSetMainSaleAverageWeeklyStatisticDataAC,
    dStatisticsSetMainSaleAverageMonthlyStatisticDataAC,
    dStatisticsSetMainRefundCountDailyStatisticDataAC,
    dStatisticsSetMainRefundCountWeeklyStatisticDataAC,
    dStatisticsSetMainRefundCountMonthlyStatisticDataAC,
    dStatisticsSetMainRefundAmountDailyStatisticDataAC,
    dStatisticsSetMainRefundAmountWeeklyStatisticDataAC,
    dStatisticsSetMainRefundAmountMonthlyStatisticDataAC,
    dStatisticsSetEmployeeStatisticDataAC,
    dStatisticsSetSaleTypeCountStatisticDataAC,
    dStatisticsSetProductStatisticDataAC,
    dStatisticsSetFullEmployeeStatisticDataAC, dStatisticsSetFullProductStatisticDataAC,
} from 'model/dashboardStatistics/dStatisticsActionCreators';
import {
    makeDayData, makeEmployeeTableData, makeFullProductTableData,
    makeHourData,
    makePaymentMethodAmountData,
    makePaymentMethodCountData, makeProductTableData,
    makeRefundAmountDailyData, makeRefundAmountMonthlyData, makeRefundAmountWeeklyData,
    makeRefundCountDailyData,
    makeRefundCountMonthlyData,
    makeRefundCountWeeklyData,
    makeSaleAmountDailyData,
    makeSaleAmountMonthlyData,
    makeSaleAmountWeeklyData,
    makeSaleAverageDailyData,
    makeSaleAverageMonthlyData,
    makeSaleAverageWeeklyData,
    makeSaleCountDailyData,
    makeSaleCountMonthlyData,
    makeSaleCountWeeklyData,
    makeSaleTypeAmountData, makeSaleTypeCountData
} from "./utils";
import {typeData} from '../../components/UI/BarChart/BarChart'
import {logoutAC} from '../system/systemActionCreators'
import {dateFilterValues} from "../../components/containers/dashboard/dataStatistics";



// Types
export type typePeriod = {
    dateFrom: string,
    dateTo: string,
}

export type typeStatisticData = {
    totalSummary: {
        count: number,
        totalAmount: number,
        averageAmount: number
    },
    dailySummary: any,
    weeklySummary: any,
    monthlySummary: any,
    cashierSummary: any,
    paymentMethodProportion: any,
    saleTypeProportion: any,
    dayOfWeekSummary: any,
    hourOfDaySummary: any,
    recordsList: any[]
}

export type typeDailyStatistic = {
    saleTotalAmount: number,
    saleCount: number,
    saleAverageAmount: number,
    refundTotalAmount: number,
    refundCount: number,
    refundAverageAmount: number,
}

export type typeEmployeeTableItem = {
    name: string,
    amount: number,
    count: number,
    average: number
}

export type typeProductTableItem = {
    store: string | null,
    name: string | null,
    amount: number,
    count: number,
    average: number
}

export type typeEmployeeFullItem = {
    name: string,
    saleTotalAmount: number,
    saleCount: number,
    saleAverageAmount: number,
    refundTotalAmount: number,
    refundCount: number,
    refundAverageAmount: number,
}

export type typeProductFullItem = {
    name: string,
    store?: string,
    saleTotalAmount: number,
    saleCount: number,
    saleAverageAmount: number,
    refundTotalAmount: number,
    refundCount: number,
    refundAverageAmount: number,
}

export type typeStatisticsState = {
    loaderDaily: boolean,
    loaderFilter: boolean,

    period: typePeriod,
    dateFilterId: dateFilterValues,
    stories: string[],

    saleStatistic: typeStatisticData | null,
    refundStatistic: typeStatisticData | null,
    dailyData: typeDailyStatistic | null,

    mainSaleAmountDayData: typeData | null,
    mainSaleAmountWeekData: typeData | null,
    mainSaleAmountMonthData: typeData | null,

    mainSaleCountDayData: typeData | null,
    mainSaleCountWeekData: typeData | null,
    mainSaleCountMonthData: typeData | null,

    mainSaleAverageDayData: typeData | null,
    mainSaleAverageWeekData: typeData | null,
    mainSaleAverageMonthData: typeData | null,

    mainRefundCountDayData: typeData | null,
    mainRefundCountWeekData: typeData | null,
    mainRefundCountMonthData: typeData | null,

    mainRefundAmountDayData: typeData | null,
    mainRefundAmountWeekData: typeData | null,
    mainRefundAmountMonthData: typeData | null,

    hoursData: typeData | null,
    weekDayData: typeData | null,
    paymentMethodAmountData: typeData | null,
    paymentMethodCountData: typeData | null,
    paymentTypeAmountData: typeData | null,
    paymentTypeCountData: typeData | null,
    employeeData: typeEmployeeTableItem[] | null,
    productData: typeProductFullItem[],

    employeeFull: typeEmployeeFullItem[],
    productFull: typeProductFullItem[],
}

/*
let dateFrom = new Date()
dateFrom.setHours(0, 0, 0, 0)

let dateTo = new Date()
dateTo.setHours(23, 59,59, 999)
*/

let weekFrom = new Date()
weekFrom.setDate(weekFrom.getDate() - 7)
weekFrom.setHours(0, 0, 0, 0)

let weekTo = new Date()
weekTo.setHours(23, 59, 59, 999)

// Init state
export const initialState: typeStatisticsState = {
    loaderDaily: false,
    loaderFilter: false,

    period: {
        dateFrom: weekFrom.toISOString(),
        dateTo: weekTo.toISOString(),
    },
    dateFilterId: dateFilterValues.WEEK,
    stories: [],


    saleStatistic: null,
    refundStatistic: null,
    dailyData: null,

    mainSaleAmountDayData: null,
    mainSaleAmountWeekData: null,
    mainSaleAmountMonthData: null,

    mainSaleCountDayData: null,
    mainSaleCountWeekData: null,
    mainSaleCountMonthData: null,

    mainSaleAverageDayData: null,
    mainSaleAverageWeekData: null,
    mainSaleAverageMonthData: null,

    mainRefundCountDayData: null,
    mainRefundCountWeekData: null,
    mainRefundCountMonthData: null,

    mainRefundAmountDayData: null,
    mainRefundAmountWeekData: null,
    mainRefundAmountMonthData: null,

    hoursData: null,
    weekDayData: null,
    paymentMethodAmountData: null,
    paymentMethodCountData: null,
    paymentTypeAmountData: null,
    paymentTypeCountData: null,
    employeeData: null,
    productData: [],

    employeeFull: [],
    productFull: [],
}


// Reducer
export const DStatisticsReducer = createReducer(initialState, builder => {
    builder

        // Reducer of set loader
        .addCase(dStatisticsSetLoaderAC, (state, action) => {
            state.loaderFilter = action.payload.loaderFilter
        })
        .addCase(dStatisticsSetDailyLoaderAC, (state, action) => {
            state.loaderDaily = action.payload.loaderDaily
        })

        // Reducer of set period
        .addCase(dStatisticsSetPeriodAC, (state, action) => {
            state.period = action.payload.period
            state.dateFilterId = action.payload.dateFilterId
        })

        // Reducer of set stories
        .addCase(dStatisticsSetStoriesAC, (state, action) => {
            state.stories = action.payload.stories
        })

        // Reducer of set sale data
        .addCase(dStatisticsSetSaleStatisticDataAC, (state, action) => {
            state.saleStatistic = action.payload.dataObj
        })

        // Reducer of set refund data
        .addCase(dStatisticsSetRefundStatisticDataAC, (state, action) => {
            state.refundStatistic = action.payload.dataObj
        })



        // Reducer of set daily data
        .addCase(dStatisticsSetDailyStatisticDataAC, (state, action) => {
            state.dailyData = action.payload.dataObj
        })



        // Reducer of set daily sale amount data
        .addCase(dStatisticsSetMainSaleAmountDailyStatisticDataAC, (state, action) => {
            state.mainSaleAmountDayData = makeSaleAmountDailyData(action.payload.dataObj)
        })
        // Reducer of set weekly sale amount data
        .addCase(dStatisticsSetMainSaleAmountWeeklyStatisticDataAC, (state, action) => {
            state.mainSaleAmountWeekData = makeSaleAmountWeeklyData(action.payload.dataObj)
        })
        // Reducer of set monthly sale amount data
        .addCase(dStatisticsSetMainSaleAmountMonthlyStatisticDataAC, (state, action) => {
            state.mainSaleAmountMonthData = makeSaleAmountMonthlyData(action.payload.dataObj)
        })



        // Reducer of set daily sale count data
        .addCase(dStatisticsSetMainSaleCountDailyStatisticDataAC, (state, action) => {
            state.mainSaleCountDayData = makeSaleCountDailyData(action.payload.dataObj)
        })
        // Reducer of set weekly sale count data
        .addCase(dStatisticsSetMainSaleCountWeeklyStatisticDataAC, (state, action) => {
            state.mainSaleCountWeekData = makeSaleCountWeeklyData(action.payload.dataObj)
        })
        // Reducer of set monthly sale count data
        .addCase(dStatisticsSetMainSaleCountMonthlyStatisticDataAC, (state, action) => {
            state.mainSaleCountMonthData = makeSaleCountMonthlyData(action.payload.dataObj)
        })



        // Reducer of set daily sale average data
        .addCase(dStatisticsSetMainSaleAverageDailyStatisticDataAC, (state, action) => {
            state.mainSaleAverageDayData = makeSaleAverageDailyData(action.payload.dataObj)
        })
        // Reducer of set weekly sale average data
        .addCase(dStatisticsSetMainSaleAverageWeeklyStatisticDataAC, (state, action) => {
            state.mainSaleAverageWeekData = makeSaleAverageWeeklyData(action.payload.dataObj)
        })
        // Reducer of set monthly sale average data
        .addCase(dStatisticsSetMainSaleAverageMonthlyStatisticDataAC, (state, action) => {
            state.mainSaleAverageMonthData = makeSaleAverageMonthlyData(action.payload.dataObj)
        })



        // Reducer of set daily refund count data
        .addCase(dStatisticsSetMainRefundCountDailyStatisticDataAC, (state, action) => {
            state.mainRefundCountDayData = makeRefundCountDailyData(action.payload.dataObj)
        })
        // Reducer of set weekly refund count data
        .addCase(dStatisticsSetMainRefundCountWeeklyStatisticDataAC, (state, action) => {
            state.mainRefundCountWeekData = makeRefundCountWeeklyData(action.payload.dataObj)
        })
        // Reducer of set monthly refund count data
        .addCase(dStatisticsSetMainRefundCountMonthlyStatisticDataAC, (state, action) => {
            state.mainRefundCountMonthData = makeRefundCountMonthlyData(action.payload.dataObj)
        })



        // Reducer of set daily refund amount data
        .addCase(dStatisticsSetMainRefundAmountDailyStatisticDataAC, (state, action) => {
            state.mainRefundAmountDayData = makeRefundAmountDailyData(action.payload.dataObj)
        })
        // Reducer of set weekly refund amount data
        .addCase(dStatisticsSetMainRefundAmountWeeklyStatisticDataAC, (state, action) => {
            state.mainRefundAmountWeekData = makeRefundAmountWeeklyData(action.payload.dataObj)
        })
        // Reducer of set monthly refund amount data
        .addCase(dStatisticsSetMainRefundAmountMonthlyStatisticDataAC, (state, action) => {
            state.mainRefundAmountMonthData = makeRefundAmountMonthlyData(action.payload.dataObj)
        })



        // Reducer of set hours statistic data
        .addCase(dStatisticsSetHoursStatisticDataAC, (state, action) => {
            state.hoursData = makeHourData(action.payload.dataObj)
        })

        // Reducer of set week day statistic data
        .addCase(dStatisticsSetWeekDayStatisticDataAC, (state, action) => {
            state.weekDayData = makeDayData(action.payload.dataObj)
        })

        // Reducer of set payment method amount statistic data
        .addCase(dStatisticsSetPaymentMethodAmountStatisticDataAC, (state, action) => {
            state.paymentMethodAmountData = makePaymentMethodAmountData(action.payload.dataObj)
        })

        // Reducer of set payment method count statistic data
        .addCase(dStatisticsSetPaymentMethodCountStatisticDataAC, (state, action) => {
            state.paymentMethodCountData = makePaymentMethodCountData(action.payload.dataObj)
        })

        // Reducer of set payment method amount statistic data
        .addCase(dStatisticsSetSaleTypeAmountStatisticDataAC, (state, action) => {
            state.paymentTypeAmountData = makeSaleTypeAmountData(action.payload.dataObj)
        })

        // Reducer of set payment method count statistic data
        .addCase(dStatisticsSetSaleTypeCountStatisticDataAC, (state, action) => {
            state.paymentTypeCountData = makeSaleTypeCountData(action.payload.dataObj)
        })

        // Reducer of set employee statistic data
        .addCase(dStatisticsSetEmployeeStatisticDataAC, (state, action) => {
            state.employeeData = makeEmployeeTableData(action.payload.dataObj, true)
        })

        // Reducer of set product statistic data
        .addCase(dStatisticsSetProductStatisticDataAC, (state, action) => {
            state.productData = makeProductTableData(action.payload.dataSaleObj, action.payload.dataRefundObj)
        })


        // Reducer of set full employee statistic data
        .addCase(dStatisticsSetFullEmployeeStatisticDataAC, (state, action) => {
            //state.productData = makeProductTableData(action.payload.dataObj, true)
        })

        // Reducer of set full product statistic data
        .addCase(dStatisticsSetFullProductStatisticDataAC, (state, action) => {
            state.productData = makeFullProductTableData(action.payload.saleDataObj, action.payload.refundDataObj)
        })


        // Reducer of clear state
        .addCase(logoutAC, (state) => {

            state.loaderDaily = false
            state.loaderFilter = false

            state.period = {
                dateFrom: weekFrom.toISOString(),
                dateTo: weekTo.toISOString(),
            }

            /*
            state.period = {
                dateFrom: dateFrom.toISOString(),
                dateTo: dateTo.toISOString(),
            }
            */

            state.dateFilterId = dateFilterValues.WEEK
            state.stories = []

            state.saleStatistic = null
            state.refundStatistic = null
            state.dailyData = null

            state.mainSaleAmountDayData = null
            state.mainSaleAmountWeekData = null
            state.mainSaleAmountMonthData = null

            state.mainSaleCountDayData = null
            state.mainSaleCountWeekData = null
            state.mainSaleCountMonthData = null

            state.mainSaleAverageDayData = null
            state.mainSaleAverageWeekData = null
            state.mainSaleAverageMonthData = null

            state.mainRefundCountDayData = null
            state.mainRefundCountWeekData = null
            state.mainRefundCountMonthData = null

            state.mainRefundAmountDayData = null
            state.mainRefundAmountWeekData = null
            state.mainRefundAmountMonthData = null

            state.hoursData = null
            state.weekDayData = null
            state.paymentMethodAmountData = null
            state.paymentMethodCountData = null
            state.paymentTypeAmountData = null
            state.paymentTypeCountData = null
            state.employeeData = null
            state.productData = []

            state.employeeFull = []
            state.productFull = []
        })

})

